import React from 'react';
import { Paper, Box, Typography, Badge, Grid, Chip } from '@mui/material';
import OrdenCard from './OrdenCard';

const KanbanColumn = ({ estado, ordenes = [], onViewOrden, onUpdateOrden }) => {
  if (ordenes.length === 0) return null;

  // Separar masters e hijas para delivery
  const masters = ordenes.filter(o => o.tipo_servicio?.toLowerCase().includes('delivery') && !o.id_orden_padre);
  const hijas = ordenes.filter(o => o.tipo_servicio?.toLowerCase().includes('delivery') && !!o.id_orden_padre);
  const normales = ordenes.filter(o => !o.tipo_servicio?.toLowerCase().includes('delivery'));

  // Agrupar hijas por padre
  const hijasPorPadre = {};
  hijas.forEach(h => {
    if (!hijasPorPadre[h.id_orden_padre]) hijasPorPadre[h.id_orden_padre] = [];
    hijasPorPadre[h.id_orden_padre].push(h);
  });

  return (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
      <Paper sx={{
        borderRadius: 3,
        overflow: 'hidden',
        height: 'calc(100vh - 380px)',
        minHeight: 500,
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #E2E8F0',
        boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
      }}>
        {/* Header */}
        <Box sx={{
          px: 2, py: 1.5,
          background: `linear-gradient(135deg, ${estado.color}, ${estado.color}DD)`,
          color: '#fff',
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" fontWeight={700}>
              {estado.nombre}
            </Typography>
            <Chip label={ordenes.length} size="small"
              sx={{ bgcolor: 'rgba(255,255,255,0.25)', color: '#fff', fontWeight: 800, height: 24, minWidth: 30 }} />
          </Box>
        </Box>

        {/* Contenido */}
        <Box sx={{
          flex: 1, overflow: 'auto', p: 1,
          bgcolor: '#FAFBFF',
          '&::-webkit-scrollbar': { width: 5 },
          '&::-webkit-scrollbar-track': { bgcolor: '#F1F5F9', borderRadius: 10 },
          '&::-webkit-scrollbar-thumb': { bgcolor: `${estado.color}66`, borderRadius: 10 },
        }}>
          {/* Servicios normales primero */}
          {normales.map(orden => (
            <OrdenCard key={orden.id_orden_servicio} orden={orden} estado={estado}
              onView={onViewOrden} onUpdate={onUpdateOrden} />
          ))}

          {/* Masters con sus hijas agrupadas */}
          {masters.map(master => (
            <Box key={master.id_orden_servicio}>
              <OrdenCard orden={master} estado={estado}
                onView={onViewOrden} onUpdate={onUpdateOrden} />
              {/* Hijas de este master en esta columna */}
              {(hijasPorPadre[master.id_orden_servicio] || []).map(hija => (
                <Box key={hija.id_orden_servicio} sx={{ pl: 1.5 }}>
                  <OrdenCard orden={hija} estado={estado}
                    onView={onViewOrden} onUpdate={onUpdateOrden} />
                </Box>
              ))}
            </Box>
          ))}

          {/* Hijas huérfanas (su padre está en otra columna) */}
          {hijas.filter(h => !masters.find(m => m.id_orden_servicio === h.id_orden_padre)).map(hija => (
            <Box key={hija.id_orden_servicio} sx={{ pl: 1.5 }}>
              <OrdenCard orden={hija} estado={estado}
                onView={onViewOrden} onUpdate={onUpdateOrden} />
            </Box>
          ))}
        </Box>
      </Paper>
    </Grid>
  );
};

export default KanbanColumn;
